module.exports = __webpack_public_path__ + "static/media/Comfortaa-Light.6a299a1b.woff";